import React from 'react';
import classNames from 'classnames';

export interface IWFNXSmallCardHeaderProps {
  children?: React.ReactNode;
  className?: string;
}

export class WFNXSmallCardHeader extends React.Component<IWFNXSmallCardHeaderProps, any> {
  render() {
    const { className } = this.props;

    return (
      <div className={classNames('wfnx-small-card-header', className)}>
        {this.props.children}
      </div>
    );
  }
}
